import { MobileItem, MobileCategory } from './components/_top/MobileSelectItems';

export const AI_FEEDBACK_TYPES = {
  IMPLICIT_POSITIVE: 'implicit_positive_feedback',
  EXPLICIT_POSITIVE: 'explicit_positive_feedback',
  EXPLICIT_NEGATIVE: 'explicit_negative_feedback',
};

export const DEVICES = {
  DESKTOP: 'desktop',
  MOBILE: 'phone',
  TABLET: 'tablet',
};

export const MOBILE_OPTIONS = [
  {
    value: 'apple',
    label: <MobileCategory name="Apple" />,
    disabled: true,
  },
  {
    value: 'iphone_17_pro',
    label: <MobileItem name="iPhone 17, 17 Pro, 16 Pro" dimension="402x874" />,
    width: 1206,
    dpr: 3,
  },
  {
    value: 'iphone_17_pro_max',
    label: <MobileItem name="iPhone 17 Pro Max, 16 Pro Max" dimension="440x956" />,
    width: 1320,
    dpr: 3,
  },
  {
    value: 'iphone_air',
    label: <MobileItem name="iPhone Air" dimension="420x912" />,
    width: 1260,
    dpr: 3,
  },
  {
    value: 'iphone_16',
    label: <MobileItem name="iPhone 16" dimension="393x852" />,
    width: 1179,
    dpr: 3,
  },
  {
    value: 'iphone_15_pro_max',
    label: <MobileItem name="iPhone 15 Pro Max" dimension="430x932" />,
    width: 1290,
    dpr: 3,
  },
  {
    value: 'google',
    label: <MobileCategory name="Google" />,
    disabled: true,
  },
  {
    value: 'pixel_9',
    label: <MobileItem name="Pixel 10, 9, 8, 7, 6" dimension="412x915" />,
    width: 1080,
    dpr: 2.625,
  },
  {
    value: 'pixel_10_pro',
    label: <MobileItem name="Pixel 10 Pro, 9 Pro" dimension="427x952" />,
    width: 1280,
    dpr: 3,
  },
  {
    value: 'pixel_10_pro_xl',
    label: <MobileItem name="Pixel 10 Pro XL, 9 Pro XL, 8 Pro" dimension="448x998" />,
    width: 1344,
    dpr: 3,
  },
  {
    value: 'pixel_7_pro',
    label: <MobileItem name="Pixel 7 Pro, 6 Pro" dimension="412x892" />,
    width: 1440,
    dpr: 3.5,
  },
  {
    value: 'samsung',
    label: <MobileCategory name="Samsung" />,
    disabled: true,
  },
  {
    value: 's24_ultra',
    label: <MobileItem name="Galaxy S24 Ultra, S23 Ultra" dimension="384x824" />,
    width: 1440,
    dpr: 3.75,
  },
  {
    value: 's24_plus',
    label: <MobileItem name="Galaxy S25 Ultra, S25+, S24+" dimension="384x832" />,
    width: 1440,
    dpr: 3.75,
  },
  {
    value: 's24',
    label: <MobileItem name="Galaxy S25, S24, S23" dimension="360x780" />,
    width: 1080,
    dpr: 3,
  },
  {
    value: 'z_fold',
    label: <MobileItem name="Galaxy Z Fold 7" dimension="728x656" />,
    width: 2184,
    dpr: 3,
  },
];

export const LUCKY = 'lucky';

export const BUTTON_TYPES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  PUBLISH: 'publish',
  CANCEL: 'cancel',
};

export const NOTIFICATION_TYPES = {
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success',
};

export const DEVICE_TO_INT = {
  [DEVICES.DESKTOP]: 0,
  [DEVICES.MOBILE]: 1,
  [DEVICES.TABLET]: 2,
};

export const LOADING = 'loading';
export const GENERATING = 'generating';
export const METRICS_PREFIX = 'editor';

export const SUGGESTION_COUNT = 3;

export const AI_IMAGE_MODEL = 'flux_pro_multi11';
export const AI_IMAGE_API = 'https://ai.crazyegg.com/api/image/text_variation';

export const SEGMENTS = {
  EVERYONE: 'EVERYONE',
  NEW_VISITORS: 'NEW_VISITORS',
  RETURNING_VISITORS: 'RETURNING_VISITORS',
  DIRECT_VISITORS: 'DIRECT_VISITORS',
  AD_TRAFFIC: 'AD_TRAFFIC',
  REFERRER: 'REFERRER',
  URL_PARAMETER: 'URL_PARAMETER',
};

/* color is RGB, for tailwind opacity to work */
export const VOICE_COLORS = [
  '83 183 255',
  '255 168 204',
  '210 135 255',
  '255 153 59',
  '245 241 158',
  '139 234 178',
  '181 229 255',
  '158 158 245',
  '251 190 255',
  '242 121 119',
];

export const VOICE_NAME_LIMIT = 25;
export const CHECK_NAME_LIMIT = 25;
export const CHECK_DEFINITION_LIMIT = 1000;
export const NEW = 'NEW';

export const AI_PROMPTS = {
  TEXT_GENERATOR: 'page-editor-generator-v3',
  IMAGE_GENERATOR: 'page-editor-image-v2',
  CHECKS: 'page-editor-checks',
  VOICE_TEST: 'page-editor-voice-test',
  SUGGESTED_FIXES: 'page-editor-suggested-fixes',
  IMPROVE_CHECK: 'page-editor-improve-check',
};
